/* eslint-disable @next/next/no-img-element */
import { FC, useMemo } from 'react';

import { useRouter } from 'next/router';

import { useTheme } from 'styled-components';

import { Typography } from '~/common/components/Typography';
import { Icon } from '~/common/components/Icons';
import { IconButton } from '~/common/components/IconButton';

import { IconAndTitle, MobileHeaderContainer, RightContent } from './styles';
import { Avatar } from '../Avatar';
import { usePrivateLayout } from '../../providers/privateLayout';

interface IMobileHeaderProps {
  openSidebar: () => void;
}
export const MobileHeader: FC<IMobileHeaderProps> = ({ openSidebar }) => {
  const { mobileHeaderTopRightContent } = usePrivateLayout();
  const theme = useTheme();
  const { asPath, query } = useRouter();

  const pageTitle = useMemo(() => {
    switch (asPath) {
      case '/deepchart':
        return 'DeepChart';
      case '/portfolio':
        return 'Portfolio';

      case '/portfolio/distribution':
        return 'Distribuição';

      // case '/portfolio/tendencies':
      //   return 'Tendências';

      case '/portfolio/wallets':
        return 'Carteiras';

      case '/social':
        return 'Social';

      case '/monitor/technical-analysis':
        return 'Análise Técnica';

      case '/monitor/btc-vs-altcoins':
        return 'BTC vs Altcoins';

      case '/monitor/news':
        return 'Notícias';

      case '/monitor/topo-hunter':
        return 'Topo Hunter';

      case '/config':
        return 'Configurações';

      case '/subscription':
        return 'Assinatura';

      case '/radar':
        return 'Radar';

      case '/radar/filters':
        return 'Alertas';

      case '/radar/filters/new':
        return 'Novo Alerta';

      case '/training':
        return 'Treinamentos';

      default: {
        if (asPath.startsWith('/radar/filters/')) {
          return 'Alterar Alerta';
        }

        if (asPath.includes('/favorite')) {
          const [coin] = (query.params as string).split('_');
          return coin;
        }
      }
    }
  }, [asPath, query]);

  const returnHref = useMemo(() => {
    switch (asPath) {
      case '/radar/filters':
        return '/radar';

      case '/radar/filters/new':
        return '/radar/filters';

      case '/portfolio/distribution':
        return '/portfolio';

      // case '/portfolio/tendencies':
      //   return '/portfolio';

      case '/portfolio/wallets':
        return '/portfolio';

      default: {
        if (asPath.includes('/portfolio/wallets')) {
          return '/portfolio';
        }

        if (asPath.startsWith('/radar/filters/')) {
          return '/radar/filters';
        }

        return null;
      }
    }
  }, [asPath]);

  const customIcon = useMemo(() => {
    switch (asPath) {
      case '/monitor/topo-hunter': {
        return (
          <img
            src="https://api.cryptocontrol.pro/images/cryptos/128x128/5.png"
            alt="logo"
            style={{
              width: '32px',
              height: '32px',
            }}
          />
        );
      }

      default: {
        if (asPath.includes('/favorite')) {
          const logo = (query.params as string).split('_')[1];
          return (
            <img
              src={logo}
              alt="logo"
              style={{
                width: '32px',
                height: '32px',
              }}
            />
          );
        }

        return null;
      }
    }
  }, [asPath, query]);

  return (
    <MobileHeaderContainer>
      <IconAndTitle>
        <Avatar />
        {returnHref ? (
          <>
            <IconButton
              icon="arrow-left-s-line"
              backgroundColor="transparent"
              borderColor={theme.neutral[700]}
              textOrIconColor={theme.neutral[400]}
              href={returnHref}
            />
            {customIcon}
            <Typography.Paragraph size="large" color="neutral.0">
              {pageTitle}
            </Typography.Paragraph>
          </>
        ) : (
          <>
            {customIcon}
            <Typography.Paragraph size="large" color="neutral.0">
              {pageTitle}
            </Typography.Paragraph>
          </>
        )}
      </IconAndTitle>

      <RightContent>
        {mobileHeaderTopRightContent}
        <Icon
          type="list-check"
          size={40}
          color={theme.neutral[0]}
          onClick={openSidebar}
        />
      </RightContent>
    </MobileHeaderContainer>
  );
};
